import apiClient from './apiClient';

const attachmentServices = {
    deleteAttachment: async (attachmentId) => {
        const response = await apiClient.delete(`/archive.php?action=delete&attachment_id=${attachmentId}`);
        return response.data;
    },

    uploadAttachment: async (file, section, subsection = null) => {
        const formData = new FormData();
        formData.append('file', file);
        if (subsection) {
            formData.append('subsection', subsection);
        } else {
            formData.append('section', section);
        }
        const response = await apiClient.post('/archive.php?action=upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    },

    fetchAttachments: async (sectionId = null, subsectionId = null) => {
        if (!sectionId && !subsectionId) {
            return { error: 'Nessuna sezione o sottosezione selezionata' };
        }

        const param = subsectionId ? `subsection_id=${subsectionId}` : `section_id=${sectionId}`;
        const response = await apiClient.get(`/archive.php?action=getAttachments&${param}`);
        const attachments = response.data;

        if (!attachments || attachments.length === 0) {
            return { message: 'Nessun allegato disponibile in archivio per questa selezione.' };
        }

        return attachments;
    },

    fetchAttachmentsBySection: async (section) => {
        return await attachmentServices.fetchAttachments(section, null);
    },
};

export default attachmentServices;
